import React from "react";
import FormattedMessage from "@irati/utils/lang";
import { H4 } from "@irati/ui/src/Typography";
var TemplateTitle = function (_a) {
    var templateText = _a.templateText;
    return (React.createElement(H4, { color: "white", textAlign: "center", margin: [1, 0] },
        React.createElement(FormattedMessage, { id: templateText })));
};
export default TemplateTitle;
